import { Component } from '@angular/core';

@Component({
    selector: 'el-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent  {}
